import { transitions, positions } from "react-alert";

export const options = {
	position: positions.BOTTOM_RIGHT,
	timeout: 4000,
	offset: "30px",
	transition: transitions.SCALE,
};
